import React from 'react';
import SortingArrowSelector from './SortingArrowSelector.js'
const isNil = require("lodash/isNil");

class ViewSwitcherHitsHeader extends React.Component {
  addTooltips(classes) {
    const hostName = this.context.searchkit.options.getLocation().hostname;
    if (!hostName.includes('localhost')) {
      switch (classes) {
        case 'interface-size':
          return window.drupalSettings.regofix_tooltips.interface_size;
        case 'norm-size':
          return window.drupalSettings.regofix_tooltips.norm_size;
        default:
          break;
      }
    }
  }
  SoringOption(classes) {
    switch (classes) {
      case 'interface-size':
        return <SortingArrowSelector field="field_interface_size_name"/>;
      case 'norm-size':
        return <SortingArrowSelector field="field_norm_size_name"/>;
      case 'o-mm':
        return <SortingArrowSelector field="o_mm"/>;
      case 'l-mm':
        return <SortingArrowSelector field="l_mm"/>;
      case 'lpr-mm':
        return <SortingArrowSelector field="lpr_mm"/>;
      default:
        break;
    }
  }
  render(){
    const tooltipText = this.addTooltips(this.props.customClasses);
    let tooltip = "";
    if (!isNil(tooltipText)) {
      tooltip = <span className="fas fa-question-circle fa-lg tooltip-icon" data-tip={tooltipText} data-for='rfTooltip'></span>
    } else {
      tooltip = null;
    }
    return (
      <div className={this.props.customClasses}>
        <div>{this.props.customText}</div>
        {tooltip}
        {this.SoringOption(this.props.customClasses)}
      </div>

    )
  }
}

export default ViewSwitcherHitsHeader



// WEBPACK FOOTER //
// ./src/ViewSwitcherHitsHeader.js